export let Brand = /*#__PURE__*/function (Brand) {
  Brand["Wix"] = "Wix";
  Brand["EditorX"] = "EditorX";
  Brand["WixStudio"] = "WixStudio";
  return Brand;
}({});
//# sourceMappingURL=brand.js.map